import { SpaceBetween } from '@amzn/awsui-components-react';
import { RouteComponentProps,Switch } from 'react-router';

import AuthenticatedPrivateRoute from '../../AuthenticatedPrivateRoute';
import { MatchParam } from '../../common/types';
import { TcoProvider } from '../../contexts/TcoContext';
import MigrationCashflow from '../migration/MigrationCashflow';
import MigrationStrategy from '../migration/MigrationStrategy';
import MigrationSummary from '../migration/MigrationSummary';
import AdjustmentsPages from './adjustments/AdjustmentsPages';
import ApplicationCostSummaryPage from './application-centric/ApplicationCostSummaryPage';
import AwsPages from './aws/AwsPages';
import MainframeSummary from './MainframeSummary';
import OnPremisesPage from './on-premises/OnPremisesPage';
import SqlServerOptimization from './sql-server-optimization/SqlServerOptimization';
import TcoActionPanel from './TcoActionPanel';
import TcoFooter from './TcoFooter';
import TcoSummary from './TCOSummary';

type TCOPagesProps = RouteComponentProps<MatchParam>;

function TCOPages(props: TCOPagesProps) {
    const { path } = props.match;
    const { pathname } = props.location;

    const pathsToExcludeTcoActionPanel: string[] = [ '/application-summary', 'adjustments/add', '/adjustments/edit' ];
    const pathsToExcludeOnlySavingsSummary: string[] = [ '/migration-strategy', '/migration/', '/mainframe-summary' ];
    const hideTcoActionPanelAndSavingsSummary = pathsToExcludeTcoActionPanel.some(page => pathname.includes(page));
    const hideTcoSavingsSummary = pathsToExcludeOnlySavingsSummary.some(page => pathname.includes(page));
    const pathsToExcludeMigrationCostFooter: string[] = [ '/migration/summary', '/migration/cash-flow' ];
    const hideMigrationCostText = pathsToExcludeMigrationCostFooter.some(page => pathname.includes(page));

    return (
        <TcoProvider>
            <SpaceBetween size='m'>
                <TcoActionPanel visible={!hideTcoActionPanelAndSavingsSummary} hideSavingsSummary={hideTcoSavingsSummary} />
                <Switch>
                    <AuthenticatedPrivateRoute path={`${path}/summary`} component={TcoSummary}/>
                    <AuthenticatedPrivateRoute path={`${path}/adjustments`} component={AdjustmentsPages}/>
                    <AuthenticatedPrivateRoute path={`${path}/aws`} component={AwsPages}/>
                    <AuthenticatedPrivateRoute path={`${path}/on-prem`} component={OnPremisesPage} />
                    <AuthenticatedPrivateRoute path={`${path}/application-summary`} component={ApplicationCostSummaryPage} />
                    <AuthenticatedPrivateRoute path={`${path}/migration-strategy`} component={MigrationStrategy} />
                    <AuthenticatedPrivateRoute path={`${path}/migration/summary`} component={MigrationSummary} />
                    <AuthenticatedPrivateRoute path={`${path}/migration/cash-flow`} component={MigrationCashflow} />
                    <AuthenticatedPrivateRoute path={`${path}/sql-server-optimization`} component={SqlServerOptimization} />
                    <AuthenticatedPrivateRoute path={`${path}/mainframe-summary`} component={MainframeSummary} />
                </Switch>
                <TcoFooter hideMigrationCostText={hideMigrationCostText}/>
            </SpaceBetween>
        </TcoProvider>
    );
}

export default TCOPages;
